<template>
	<div>
		<b-row class="justify-content-lg-center">
			<b-col>
				<b-card-title>{{ $t('worker_title_edit') }}</b-card-title>
                <b-form @submit="submit" validate>
                    <b-row>
                        <b-col>
                            <div class="form-group form-row m-b-15">
                                <label class="col-form-label col-md-3">{{ $t('worker_form_label_firstname') }}</label>
                                <div class="col-md-9">
                                    <input v-model="firstname" type="text" class="form-control m-b-5" :placeholder="$t('worker_form_placeholder_firstname')" required />
                                </div>
                            </div>
                            <div class="form-group form-row m-b-15">
                                <label class="col-form-label col-md-3">{{ $t('worker_form_label_lastname') }}</label>
                                <div class="col-md-9">
                                    <input v-model="lastname" type="text" class="form-control m-b-5" :placeholder="$t('worker_form_placeholder_lastname')" />
                                </div>
                            </div>
                            <div class="form-group form-row m-b-15">
                                <label class="col-form-label col-md-3">{{ $t('worker_form_label_is_active') }}</label>
                                <div class="col-md-9">
                                    <b-form-checkbox
                                        v-model="isActive"
                                        :value="true"
                                        :unchecked-value="false"
                                    />
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="justify-content-lg-center">
                        <b-col>
                            <hr />
                            <a :href="`/worker`" type="button" class="btn btn-secondary">{{ $t('worker_button_back_to_list') }}</a>
                            <b-button class="ml-2" @click="showDeleteModal" variant="danger">{{ $t('worker_button_delete') }}</b-button>
                            <b-button class="ml-2" type="submit" variant="primary">{{ $t('worker_button_save') }}</b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </b-col>
        </b-row>

		<b-modal 
            ref="confirmDeleteModal" 
            size="md" 
            :title="$t('worker_delete_modal_title')" 
            ok-only
            :ok-title="$t('worker_delete_modal_button_ok')"
            @ok="deleteSubmit"
        >
			{{ $t('worker_delete_modal_text') }}
		</b-modal>
	</div>
</template>

<script>
export default {
    name: 'WorkerEdit',
    props: ['worker', 'workerEditCall', 'workerDeleteCall'],
    data() {
        return {
            firstname: '',
            lastname: '',
            isActive: false,
        }
    },
    methods: {
		submit() {
            event.preventDefault();
            this.workerEditCall(this.worker.id, JSON.stringify(
                {
                    firstname: this.firstname,
                    lastname: this.lastname,
                    isActive: this.isActive,
                }
            ));
        },
		showDeleteModal() {
            this.$refs['confirmDeleteModal'].show();
        },
		deleteSubmit() {
            this.workerDeleteCall(this.worker.id);
        },
        setFormValues() {
            if (!this.name && this.worker) {
                this.firstname = this.worker.firstname
                this.lastname = this.worker.lastname
                this.isActive = this.worker.isActive
            }
        }
    },
    mounted() {
        this.setFormValues();
    },
    watch: {
        worker: function () {
            if (this.worker) {
                this.setFormValues();
            }
        }
    }
}
</script>